module.exports = __webpack_public_path__ + "static/media/history-start.7f442ad3.svg";